export default class User {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.login = null;
        this.password = null;
        this.token = null;
        this.email = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/user.model.js